import React from "react";
import { Flower2Icon, ArrowRightIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { Countdown } from "../Countdown";
import { images } from "../../data/offer";
const heroFlow = ["Prepare", "Orient", "Practice", "Close", "Record"];
export function Hero() {
  return <header className="bg-cream px-5 pb-16 pt-8 sm:pt-12" data-id="element-184" data-mp="hvh1ikis45zm">
      <div className="mx-auto max-w-5xl text-center" data-id="element-185" data-mp="hsuvwqfg80k1">
        <div className="flex flex-col items-center gap-3 sm:flex-row sm:justify-center" data-id="element-186" data-mp="mszcshk9qxas">
          <div className="flex items-center gap-2.5" data-id="element-187" data-mp="quu9t9v62oir">
            <span className="grid h-11 w-11 place-items-center rounded-xl bg-brand text-cream" data-id="element-188" data-mp="qt9gfnkl9bmh">
              <Flower2Icon className="h-6 w-6" aria-hidden="true" data-id="element-189" data-mp="vof9r7gblskl" />
            </span>
            <span className="font-serif text-xl font-bold text-brand" data-id="element-190" data-mp="10knju6fnuvkw">Reflexology Session Blueprint™</span>
          </div>
          <span className="rounded-full border border-brand/20 bg-white px-3 py-1 text-xs font-bold uppercase tracking-wider text-brand" data-id="element-191" data-mp="15ip773k4dh26">
            The Visual Reflexology Practice System
          </span>
        </div>

        <h1 className="mx-auto mt-7 max-w-4xl font-serif text-[2.35rem] font-extrabold leading-[1.08] text-ink sm:text-6xl" data-id="element-192" data-mp="4o6mpojyd38k">
          Organize a reflexology practice session{" "}
          <em className="text-coral" data-id="element-193" data-mp="3rtfgcgkw6lmu">in up to 15 minutes</em>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-ink/80 sm:text-xl" data-id="element-194" data-mp="3rv8mzvvi95uu">
          One simple visual system so you can stop jumping between charts, notes, videos and PDFs every time you want to practice. Includes{" "}
          <strong className="text-ink" data-id="element-195" data-mp="io8xyrxr8yeu">6 volumes</strong> and <strong className="text-ink" data-id="element-196" data-mp="imo65a2trtko">5 bonuses</strong>.
        </p>

        <ul className="mx-auto mt-6 flex max-w-xl flex-wrap items-center justify-center gap-x-1.5 gap-y-2" aria-label="Session structure" data-id="element-197" data-mp="eluimhtaogsb">
          {heroFlow.map((step, i) => <li key={step} className="flex items-center gap-1.5" data-id="element-198" data-mp="16djutybzi8np" data-mpi={i}>
              <span className="rounded-lg bg-brand px-2.5 py-1.5 text-xs font-bold uppercase tracking-wider text-cream sm:text-sm" data-id="element-199" data-mp="16c8pvv6syuv0">{step}</span>
              {i < heroFlow.length - 1 && <ArrowRightIcon className="h-4 w-4 text-brand/60" aria-hidden="true" data-id="element-200" data-mp="35kh3umkqg8uv" />}
            </li>)}
        </ul>

        <img src={images.mockup} alt="Reflexology Session Blueprint™ — 6 volumes and 5 bonuses" className="mx-auto mt-6 w-full max-w-3xl" data-id="element-201" data-mp="2qu9ssrx21s47" />

        <CTAButton id="hero-cta" label="Yes! I want my Reflexology Session Blueprint™" className="mt-4" data-id="element-202" data-mp="2hu4kmfk1epoz" />

        <Countdown className="mt-9" data-id="element-203" data-mp="2msfv8si5p489" />

        <p className="mt-6 text-lg font-semibold text-ink" data-id="element-204" data-mp="27xrt9obysnxe">
          Get Reflexology Session Blueprint™ today for just <span className="text-coral" data-id="element-205" data-mp="2cvjksh8p6812">$27</span>
        </p>
        <p className="mt-1 text-sm text-ink/70" data-id="element-206" data-mp="2cy62vat7s5xj">One-time payment · No monthly fees · Instant digital access</p>
      </div>
    </header>;
}